import { Boxes, CalendarCheck, ClipboardList, Sparkles, Star, TrendingUp } from "lucide-react";
import { Reveal } from "./Reveal";

const BENEFITS = [
  {
    id: "patients",
    icon: CalendarCheck,
    title: "Patients & Appointments",
    text: "Records, schedules and follow-ups stay organized — so every patient gets the attention they deserve.",
  },
  {
    id: "treatment",
    icon: ClipboardList,
    title: "Treatment & Lab Work",
    text: "Track treatment plans and lab work alongside appointments, so nothing slips through the cracks.",
  },
  {
    id: "inventory",
    icon: Boxes,
    title: "Smart Inventory",
    text: "Know what you have and what you're running low on — before it interrupts a procedure.",
  },
  {
    id: "leads",
    icon: Star,
    title: "Leads, Reviews & Posts",
    text: "Manage leads, Google Reviews and Google Business Profile posts from the same place you run your clinic.",
  },
  {
    id: "finances",
    icon: TrendingUp,
    title: "Finances & Analytics",
    text: "Your real numbers — collections, performance and trends — clear enough to plan your next move.",
  },
  {
    id: "diva",
    icon: Sparkles,
    title: "DIVA, Your AI Assistant",
    text: "Ask questions about your clinic and get insights and actionable guidance drawn from your own data.",
  },
];

const Benefits = () => (
  <section id="features" data-testid="benefits-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">Why DENSA</p>
        <h2 className="mt-4 text-2xl font-bold tracking-tight text-brand-ink sm:text-3xl lg:text-4xl">
          Less administration. <span className="text-brand">More dentistry.</span>
        </h2>
        <p className="mt-4 text-base leading-relaxed text-slate-600">
          Every capability in DENSA exists to remove a real burden from a dentist&apos;s day.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {BENEFITS.map(({ id, icon: Icon, title, text }, i) => (
          <Reveal key={id} delay={i * 0.07}>
            <article
              data-testid={`benefit-card-${id}`}
              className="group h-full rounded-2xl border border-slate-200/80 bg-[#F8FAF9] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-brand/30 hover:bg-white hover:shadow-xl hover:shadow-brand/10 sm:p-7"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-mint transition-colors duration-300 group-hover:bg-brand">
                <Icon className="h-5 w-5 text-brand transition-colors duration-300 group-hover:text-white" aria-hidden="true" />
              </span>
              <h3 className="mt-5 text-lg font-semibold text-brand-ink">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Benefits;
